export default {
  // ページタイトルとサブタイトル
  title: 'マイペット',
  subtitle: '{{count}}匹のペットがいます',
  
  // ロードとエラー状態
  checkingAuth: '認証を確認中...',
  loadingPets: 'ペットデータを読み込み中...',
  fetchErrorTitle: 'ペットデータを読み込めません',
  retry: '再試行',
  
  // 空の状態
  noPetsTitle: 'まだペットがいません',
  noPetsSubtitle: '最初のペットプロフィールを作成しましょう',
  addFirstPet: '最初のペットを追加',
  
  // アクションボタン
  addPet: 'ペットを追加',
  edit: '編集',
  delete: '削除',
  share: '共有',
  shareNow: '今すぐ共有',
  preview: 'プレビュー',
  viewFullDetails: '詳細を表示',
  
  // 表示モード
  gridView: 'グリッド表示',
  listView: 'リスト表示',
  
  // 統計
  statistics: '統計',
  totalPets: 'ペット総数',
  registeredPets: '登録済み',
  averageAge: '平均年齢',
  allPets: 'すべてのペット',
  weeklyAdded: '今週追加',
  recentlyAdded: '最近追加',
  mostCommonType: '最も一般的なタイプ',
  
  // 検索とフィルター
  searchPlaceholder: 'ペット名、品種、タイプを検索...',
  sortByName: '名前で並べ替え',
  sortByCreated: '作成日で並べ替え',
  sortByType: 'タイプで並べ替え',
  showingResults: '{{current}} / {{total}} 匹のペットを表示',
  noMatchingPets: '一致するペットがありません',
  searchKeyword: '検索キーワード: {{keyword}}',
  typeFilter: 'タイプフィルター: {{type}}',
  clearFilters: 'フィルターをクリア',
  
  // ペット情報
  unnamedPet: '名前未設定のペット',
  unknownBreed: '品種不明',
  yearsOld: '歳',
  nextFeeding: '次回給餌',
  nextMedication: '次回投薬',
  nextVetVisit: '次回獣医訪問',
  location: '場所',
  home: '自宅',
  notSet: '未設定',
  
  // 削除確認
  deleteError: '削除に失敗しました。もう一度お試しください',
  deleteSuccess: 'ペットが正常に削除されました'
};